import { hotelCheckInOptions } from 'components/elements/table/editable-columns/check-in-options';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { mealsOption } from 'legacy-modules/master/hotel/components/utils';
import useTranslation from 'next-translate/useTranslation';

import { HotelRescheduleDetailHotelFormType } from '../form-type';

export default function useGetHotelRescheduleDetailTableList() {
  const { t } = useTranslation();

  const columns: IColumn<HotelRescheduleDetailHotelFormType>[] = [
    {
      header: t('common:status'),
      accessorKey: 'checkInStatus',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.select,
      options: hotelCheckInOptions(t),
    },
    {
      header: t('common:check_in'),
      accessorKey: 'checkIn',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:check_out'),
      accessorKey: 'checkOut',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:hotel_confirmation'),
      accessorKey: 'hotelConfirmationCode',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:meals'),
      accessorKey: 'detail',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.select,
      options: mealsOption,
    },
    {
      header: t('common:pax'),
      accessorKey: 'pax',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
    {
      header: t('common:number_of_night'),
      accessorKey: 'night',
      minSize: 100,
      dataType: ColumnDataType.null,
    },
    {
      header: t('common:number_of_room'),
      accessorKey: 'room',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
    {
      header: t('common:room_type'),
      accessorKey: 'hotelRoomName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];
  return columns;
}
